<div appModal [mainClass]="'lg-modal'" (closeModal)="close()">
  <section class="modal-title-container">
    <div class="modal--title pr-25">Crop and upload your profile image</div>
  </section>
  <section class="modal-content-container">
    <div class="cropper-container">
      <image-cropper
        [imageBase64]="imageDataUrl"
        [maintainAspectRatio]="true"
        [aspectRatio]="1 / 1"
        (imageCropped)="imageCropped($event)"
        *ngIf="showCropper"
      ></image-cropper>
    </div>
  </section>
  <section class="modal-actions-container">
    <button class="btn btn-lg btn-grey" (click)="close()">Cancel</button>
    <button class="btn btn-lg ml-20" (click)="save()">Save</button>
  </section>
</div>
